// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconMedImaging_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s16IconSvg = html `<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M0 4H2V2L4 2V0H0V4ZM16 0H12V2L14 2V4H16V0ZM4 16V14H2V12H0V16H4ZM14 14H12V16H16V12H14V14ZM8 10C9.10457 10 10 9.10457 10 8 10 6.89543 9.10457 6 8 6 6.89543 6 6 6.89543 6 8 6 9.10457 6.89543 10 8 10Z" class="svg-bg"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M15 8C14.2229 10.8754 11.2616 13 7.99993 13C4.73821 13 1.77707 10.8754 1 8C1.77707 5.12462 4.73821 3 7.99993 3C11.2616 3 14.2229 5.12462 15 8ZM3.11384 8C3.83551 9.66571 5.75993 11 7.99993 11C10.24 11 12.1645 9.66568 12.8862 8C12.1645 6.33432 10.24 5 7.99993 5C5.75993 5 3.83551 6.33429 3.11384 8Z" class="svg-bg"/>
</svg>
`;
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M22 2H19V0H24V5H22V2ZM5 0V2H2V5H0V0H5ZM0 19H2V22H5V24H0V19ZM19 24V22H22V19H24V24H19Z" class="svg-bg"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M15.999 12C15.999 14.2091 14.2087 16 12.0002 16C9.79177 16 8.00146 14.2091 8.00146 12C8.00146 9.79086 9.79177 8 12.0002 8C14.2087 8 15.999 9.79086 15.999 12ZM13.9996 12C13.9996 13.1046 13.1045 14 12.0002 14C10.896 14 10.0008 13.1046 10.0008 12C10.0008 10.8954 10.896 10 12.0002 10C13.1045 10 13.9996 10.8954 13.9996 12Z" class="svg-bg"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M12 4C17.4062 4 22.0415 7.3021 24 12C22.0415 16.6979 17.4067 20 12.0005 20C6.59424 20 1.95852 16.6979 0 12C1.95852 7.3021 6.59376 4 12 4ZM12.0005 18C16.2739 18 19.9779 15.5617 21.7981 12C19.9779 8.43833 16.2734 6 12 6C7.72662 6 4.02306 8.43832 2.20291 12C4.02306 15.5617 7.72711 18 12.0005 18Z" class="svg-bg"/>
</svg>
`;
/**
 * IconMedImaging is a generated icon component.
 */
let IconMedImaging = IconMedImaging_1 = class IconMedImaging extends IconBaseElement {
    render() {
        return html `${IconMedImaging_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconMedImaging.icons = new Map([
    ['s8', _s16IconSvg],
    ['s12', _s16IconSvg],
    ['s16', _s16IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s24IconSvg],
    ['s40', _s24IconSvg],
    ['s48', _s24IconSvg],
    ['s64', _s24IconSvg],
    ['s72', _s24IconSvg],
    ['s80', _s24IconSvg],
]);
IconMedImaging = IconMedImaging_1 = __decorate([
    customElement('zui-icon-med-imaging')
], IconMedImaging);
export { IconMedImaging };
